// removed by extract-text-webpack-plugin
module.exports = {"box":"_1pqrQTzEOVfHXYYnvgao-g","sm":"q1h6p6uXSBoJ2oIJSkf1S","md":"fm6K3zH2PaZ62xcqRTisX","noBorder":"_3yIbg0wiRuILkTYpfd1nQ-","fullWidth":"_2BHlYgO0ghVkaFrsdPWk0M","default":"_2yss1p7pa_JtS-LC4md_0D","muted":"_38aFHCW-t7n5SzGda71lCC","danger":"_1HirbjG-3ykT4fFkNvFB8v","success":"pP76gVAKZKtf1PS8jnl0Y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoBox.scss
// module id = 1231
// module chunks = 0